import { Injectable } from '@angular/core';
import { catchError, forkJoin, map, Observable, of, switchMap } from 'rxjs';
import { PricingItemVersion } from '../../models/quote/pricing-item-version';
import { ProductSearchRequestV2 } from '../../models/quote/product-search-request-v2';
import { Page } from '../../utils/page';
import { ProductMapperV2Service } from './product-mapper-v2.service';
import { ProductWithChildrenV2 } from '../../models/productv2/productv2-children.model';
import { PriceList } from '../../models/productv2/pricelist.model';
import { ProductV2 } from '../../models/productv2/productv2.model';
import { AtomicProductV2 } from '../../models/productv2/atomic-productv2.model';
import { KitProductV2 } from '../../models/productv2/kit-productv2.model';
import { PackProductV2 } from '../../models/productv2/pack-productv2.model';

@Injectable()
export abstract class ProductManagerV2Service {

    protected API_URL = '/apiProduct2/v2';

    constructor(protected productMapper: ProductMapperV2Service) {
    }

    abstract searchArticles(productSearchRequest: ProductSearchRequestV2, pageable: Map<string, string>): Observable<Page<ProductWithChildrenV2>>;

    abstract searchAtomicArticles(productSearchRequest: ProductSearchRequestV2, pageable: Map<string, string>): Observable<Page<ProductWithChildrenV2>>;

    abstract getActivePricingItemVersion(countryIsoCode: string, versionType: string): Observable<PricingItemVersion>;

    abstract getClassification(id: number): Observable<PriceList>;

    abstract searchArticlesByFilteredElisCodes(productSearchRequestV2: ProductSearchRequestV2): Observable<{ content: ProductWithChildrenV2[] }>;

    //FIXME : here we load all pricelists for all product searched => QuoteWrapperDuplicator => updateProductPricing : load only pricelist by found product
    searchArticlesByFilteredElisCodesGrouped(productSearchRequestV2: ProductSearchRequestV2): Observable<{ service: string, products: ProductV2[] }[]> {
        return this.searchArticlesByFilteredElisCodes(productSearchRequestV2).pipe(
            map(products => this.productMapper.createDistinctProductV2List(products.content)),
            switchMap(products => this.loadPriceLists(products)),
            map(products => this.productMapper.groupProductsByService(products))
        );
    }


    loadPriceLists(products: ProductV2[]): Observable<ProductV2[]> {

        if (!products) {
            return of([]);
        }

        const requests: Observable<any>[] = products.flatMap(p =>
            this.buildPriceListRequest(p)
        );

        if (requests.length === 0) {
            return of(products);
        }

        return forkJoin(requests).pipe(map(() => products));
    }

    private buildPriceListRequest(product: ProductV2): Observable<any>[] {
        const requests: Observable<any>[] = [];

        const pushRequest = (product?: ProductV2) => {
            if (product["priceListId"] && !product.priceList) {
                requests.push(
                    this.getClassification(product["priceListId"]).pipe(
                        map(classification => product.priceList = classification),
                        catchError(err => {
                            console.error(`Erreur pricelist product id `, product.id, err);
                            return of(null);
                        })
                    )
                );
            }
        };

        if (product instanceof AtomicProductV2 || product instanceof PackProductV2) {
            pushRequest(product);
        }

        if (product instanceof KitProductV2) {
            pushRequest(product.device);
            pushRequest(product.consumable);
        }

        return requests;
    }

}
